<section class="flex flex-column consult__section">
  <div class="inline-flex align-items-center justify-content-between consult__section-subheading-group">
    <h2 class="consult__section-subheading">
      <label for="diagnostic_{{turn}}" class="field__label no-margin">{{screen.labels.diagnostic.heading}}</label>
    </h2>
    <span class="consult__section-help" [style.width.%]="50">{{screen.labels.diagnostic.help}}</span>
  </div>

  <div class="col-12 px-0 inline-flex">
    <div class="col-fixed px-0" [style.width.px]="50" *ngIf="!readonly"></div>
    <label class="col pl-0 no-margin"
      for="diagnostic_description_0_{{turn}}">{{screen.labels.diagnostic.description}}</label>
    <label class="col-fixed px-0 text-center no-margin"
      [style.width.px]="60">{{screen.labels.diagnostic.pre}}</label>
    <label class="col-fixed px-0 text-center no-margin"
      [style.width.px]="60">{{screen.labels.diagnostic.def}}</label>
  </div>

  <div *ngFor="let diagnostic of value; let idx = index">
    <ms-consult-diagnostic-item [(ngModel)]="value[idx]" [idx]="idx" [turn]="turn" (remove)="removeDiagnostic(idx)"
      [readonly]="readonly">
    </ms-consult-diagnostic-item>
  </div>

  <div class="text-center add-item-btn" *ngIf="!readonly">
    <button pButton icon="fas fa-plus" type="button" class="p-button-success p-button-rounded p-button-outlined"
      (click)="value.push({ patient: patient })">
    </button>
  </div>
</section>